import React from "react";
import SetupTankTable from "./components/SetupTankTable";

const SetupTankInfo = () => {
  return <SetupTankTable />;
};

export default SetupTankInfo;
